<template>
  <label class="wrapper">
    <!-- {{label}} -->
    <input class="checkbox" :class="value" type="radio" :checked="isChecked" :value="value" @change="$emit('change', $event.target.value)" />
    <span class="checkmark" :class="value"></span>
  </label>
</template>

<script>
export default {
  name: 'RadioBox',

  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    label: { type: String, default: '', required: false },
    modelValue: { default: '' },
    value: { type: String, default: undefined },
  },
  computed: {
    isChecked() {
      return this.modelValue == this.value;
    },
  },
};
</script>

<style lang="postcss" scoped>
/* Customize the label (the wrapper) */
.wrapper {
  position: relative;
  padding-left: 26px;
  /* margin-bottom: 6px; */
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
}

/* Hide the browser's default radio button */
.wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 21px;
  width: 21px;
  border-radius: 50%;
  /* border: 1px solid #ccc; */
}

/* On mouse-over, add a grey background color */
.wrapper:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.checkbox:checked ~ .checkmark {
  background-color: #1cd4a7;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.wrapper input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.wrapper .checkmark:after {
  top: 5px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  /* background: white; */
}
.default:checked ~ .checkmark {
  background-color: #aaa !important;
  color: #fff !important;
  border: 2px solid gray !important;
}
.typeA:checked ~ .checkmark {
  background-color: #666666 !important;
  color: #fff !important;
  border: 2px solid gray !important;
}
.typeB:checked ~ .checkmark {
  background-color: #42b983 !important;
  color: #fff !important;
  border: 2px solid gray !important;
}
.typeC:checked ~ .checkmark {
  background-color: rgba(255, 102, 102, 1) !important;
  color: #fff !important;
  border: 2px solid gray !important;
}
</style>